/* =========================================================
   AF Vendor Brand Marquee v3 — assets/af-vendor-brand-marquee.js
   ⚡ Minimal — CSS animates; JS computes exact pixel shift + duration
   ========================================================= */
(() => {
  "use strict";

  const TOUCH_RESUME_MS = 500;

  const boot = () => {
    document.querySelectorAll("[data-af-vm]").forEach(init);
  };

  // Defer init until after first paint to avoid blocking FCP
  if ("requestIdleCallback" in window) {
    requestIdleCallback(boot);
  } else {
    // Safari has no requestIdleCallback; this script can arrive after load
    if (document.readyState === "complete") boot();
    else window.addEventListener("load", boot, { once: true });
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      const r = e.target.querySelector("[data-af-vm]");
      if (r) init(r);
    });
  }

  function init(root) {
    if (!root || root.dataset.afVmInit === "1") return;
    root.dataset.afVmInit = "1";

    const track    = root.querySelector("[data-af-vm-track]");
    const viewport = root.querySelector("[data-af-vm-viewport]");
    if (!track || !viewport) return;

    const speed = Math.max(5, parseFloat(root.dataset.speed || "45")); // px/s

    function setVars() {
      // Half of the duplicated track width in px — this is the *exact* loop distance.
      const halfW = track.scrollWidth / 2;

      if (halfW > 0) {
        const dur = (halfW / speed).toFixed(1) + "s";
        root.style.setProperty("--af-vm-shift", halfW.toFixed(0) + "px");
        root.style.setProperty("--af-vm-duration", dur);
      }
    }

    setVars();

    let touchTimer = 0;

    viewport.addEventListener("touchstart", () => {
      track.classList.add("is-touch-paused");
      clearTimeout(touchTimer);
    }, { passive: true });

    viewport.addEventListener("touchend", () => {
      clearTimeout(touchTimer);
      touchTimer = setTimeout(() => {
        track.classList.remove("is-touch-paused");
      }, TOUCH_RESUME_MS);
    }, { passive: true });

    // ResizeObserver: recalc on layout changes (fonts, viewport width, theme editor changes).
    // Only observe viewport — track width is derived from its children and viewport width,
    // so observing both caused redundant callbacks and extra scrollWidth reads.
    let resizeTimer;
    new ResizeObserver(() => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setVars, 150);
    }).observe(viewport);
  }
})();
